import { useContext, useState } from 'react';
import { Container } from 'react-bootstrap';
import { ThemeContext } from '../../context/theme-context';
import ListNotasFiscais from '../../Components/Vendas/NotasFiscais/ListNotasFiscais';
import FormEmitirNfe from '../../Components/Vendas/EmitirNfe/FormEmitirNfe';

export default function CadNotasFiscais() {
  const { collapsed } = useContext(ThemeContext);
  const [showForm, setShowForm] = useState<boolean>(false);

  const handleEmitir = () => {
    setShowForm(true);
  };

  const handleCancel = () => {
    setShowForm(false);
  };

  return (
    <>
      {!showForm ? (
        <Container
          className={collapsed ? 'contenteLayoutCollapsed' : 'contenteLayout'}
        >
          <ListNotasFiscais
            title="Notas Fiscais Eletrônicas"
            onEmitir={handleEmitir}
          />
        </Container>
      ) : (
        <Container
          className={collapsed ? 'contenteLayoutCollapsed' : 'contenteLayout'}
        >
          <FormEmitirNfe
            title="Emitir Nova Nota Fiscal Eletrônica"
            onCancel={handleCancel}
          />
        </Container>
      )}
    </>
  );
}